import { useDispatch } from 'react-redux';
import { commonActions } from '@/redux/modules';
import useLocale from '@/hooks/useLocale';
import { copyTextToClipboard } from '@/utils/Application/copyTextToClipboard';

/**
 * Hook that provides a copy-to-clipboard function with automatic toast notifications.
 * @returns {Function} copyToClipboard function that accepts (textToCopy, contentId)
 */
export const useCopyToClipboard = () => {
  const dispatch = useDispatch();
  const { sharedUi: sharedUiLocale } = useLocale();

  const copyToClipboard = async (textToCopy, contentId = null) => {
    try {
      await copyTextToClipboard(textToCopy, contentId);
      dispatch(commonActions.notifications.set({
        toast: {
          title: sharedUiLocale.clipboard.copyToClipboard.success,
          info: '',
          showIcon: true,
          context: 'positive',
        },
      }));
    } catch (error) {
      dispatch(commonActions.notifications.set({
        toast: {
          title: sharedUiLocale.clipboard.copyToClipboard.error,
          info: '',
          showIcon: true,
          context: 'negative',
        },
      }));
    }
  };

  return copyToClipboard;
};
